export const ROUTER_PATHS = {
    Bom: "bom",
    CycleDashboard: "cycle-dashboard",
    ViewShipmentSummary: "view-shipment-summary",
    Distribution: "/userlogin/distribution",
    Nar: {
    GenerateNAR: "generate-nar",
    ViewNAR: "view-nar",
    EditNAR: "edit-nar",
    GenerateNARNewCustomer: "/generate-nar-new-customer",
    GenerateNARNewRoute: "/userlogin/distribution/generate-nar-new-customer",
    },
ValidationLetter:{
        GenerateValidationLetters: "generate-validation-letters"

}
}